import 'style-loader!./progress-spinner.css';
import idGenerator from 'cadenza/utils/id-generator';
import h from 'hyperscript';

const labelIdGen = idGenerator('progress-spinner-label');

class ProgressSpinner extends HTMLElement {

  constructor () {
    super();
    const labelId = labelIdGen.next().value;
    this._progress = h('div.progress-spinner', {
      attrs: {role: 'progressbar', 'aria-labeledby': labelId}
    });
    this._label = h('span.progress-spinner-label', {id: labelId});
  }

  connectedCallback () {
    this.classList.add('progress-spinner-container');
    this.innerHTML = '';
    this.append(this._progress, this._label);

    if (!this.label) {
      this.label = this.getAttribute('label');
    }
  }

  set label (value) {
    this._label.textContent = value;
  }

  get label () {
    return this._label.textContent;
  }

}

customElements.define('progress-spinner', ProgressSpinner);
